import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react'

interface Props {
  errors: Record<string, any>
  setErrors: Dispatch<SetStateAction<Record<string, any>>>
}

export const StoreEditItemContext = createContext<Props | null>(null)

export const StoreEditItemProvider = ({ children }: PropsWithChildren) => {
  const [errors, setErrors] = useState({})
  const value = useMemo(() => ({ errors, setErrors }), [errors, setErrors])
  return <StoreEditItemContext.Provider value={value}>{children}</StoreEditItemContext.Provider>
}

export const useStoreEditItemContext = () => {
  const context = useContext(StoreEditItemContext)
  if (!context) {
    throw new Error('useStoreEditItemContext must be used within a StoreEditItemProvider')
  }
  return context
}
